import { render } from "./copyright.vue?vue&type=template&id=12e822c8&scoped=true"
const script = {}

import "./copyright.vue?vue&type=style&index=0&id=12e822c8&scoped=true&lang=css"

import exportComponent from "/Users/hansteve/Desktop/work/qingshui/qingshui_home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e822c8"]])

export default __exports__